import { FC, useEffect, useState } from "react";
import { GenericStoryElementComponentProps, GenericStorylineElementsList } from "../GeneralComponents/generic-storyline-list";
import { StoryElement } from "../storyelements-management/story-element";
import StorylineServerProxy from "../storyline-proxy/storyline-proxy";
import { Button, Checkbox, Link, Paper, TextField } from "@mui/material";
import { useDebounce } from "@uidotdev/usehooks";


const EngageChannelSetter:FC<GenericStoryElementComponentProps> = ({ storyElement }) => {

    const [titleOverride, setTitleOverride] = useState(((storyElement.engageTitleOverride != null) && (storyElement.engageTitleOverride != ""))?storyElement.engageTitleOverride:storyElement.title);

    const [selectedForEngage, setSelectedForEngage] = useState(storyElement.selectedForEngage);

    const titleOverrideDebounced = useDebounce(titleOverride, 1000);

    useEffect(() => {
        const newStoryElement = {
            ... storyElement,
            selectedForEngage: selectedForEngage,
            engageTitleOverride: titleOverrideDebounced,
        }

        StorylineServerProxy.updateStoryElement(newStoryElement);
    }, [titleOverrideDebounced, selectedForEngage])


    function handleTitleOverrideChanged(event: any){
        setTitleOverride(event.target.value);
    }

    function handleSelectedForEnageChanged(event: any){
        setSelectedForEngage(event.target.checked);
    }

    return(
        <>
            <Paper elevation={6}  sx={{ padding: 3, margin:0}}>
                <Checkbox checked={selectedForEngage} onChange={handleSelectedForEnageChanged}></Checkbox> { storyElement.company } - <Link href={ storyElement.link } target="child">{ storyElement.title }</Link>
                <br/>
                <TextField value={titleOverride} onChange={handleTitleOverrideChanged} sx={{ width: 9/10 }} placeholder="Title override"></TextField>
            </Paper>
        </>
    )
}

export default function EngageChannelSetterPage(){

    let [storyElements, setStoryElements] = useState([] as StoryElement[]);

    useEffect(() => {
        StorylineServerProxy.getJobs(50, 0).then(elements => { setStoryElements(elements)} )
    }, []);

    return (
        <GenericStorylineElementsList storyElements={storyElements} Component={EngageChannelSetter} updateListFromServer={null} />
    )
}
